import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Keyboard } from 'swiper/modules'; 
import type { Swiper as SwiperType } from 'swiper'; 

import 'swiper/css';

import CorporateIdentity from './components/corporate_identity';
import Business from './components/business';
import Representative from './components/representative';
import Company from './components/company';
import Recruit from './components/recruit';
import Contact from './components/contact';
import Header from './components/Header';
import { Box } from '@mui/material';

const App = () => {
  const swiperRef = useRef<SwiperType | null>(null);

  const scrollToSection = (id: string) => {
    const sectionIndex: Record<string, number> = {
      section1: 0,
      section2: 1,
      section3: 2,
      section4: 3,
      section5: 4,
      section6: 5,
    };
    
    if (swiperRef.current && sectionIndex[id] !== undefined) {
      swiperRef.current.slideTo(sectionIndex[id]);
    }
  };

  return (
    <Box sx={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <Header scrollToSection={scrollToSection} />
      
      <Swiper
        direction={'vertical'}
        slidesPerView={1}
        mousewheel={true}
        keyboard={{
          enabled: true,
          onlyInViewport: true,
        }}
        speed={800} 
        modules={[Mousewheel, Keyboard]}
        onSwiper={(swiper: SwiperType) => {
          swiperRef.current = swiper;
        }}
        style={{ width: '100%', height: '100vh' }}
      >
        <SwiperSlide><Box sx={{ height: '100vh' }}><CorporateIdentity /></Box></SwiperSlide>
        <SwiperSlide><Box sx={{ height: '100vh' }}><Business /></Box></SwiperSlide>
        <SwiperSlide><Box sx={{ height: '100vh' }}><Representative /></Box></SwiperSlide>
        <SwiperSlide><Box sx={{ height: '100vh' }}><Company /></Box></SwiperSlide>
        <SwiperSlide><Box sx={{ height: '100vh' }}><Recruit /></Box></SwiperSlide>
        <SwiperSlide><Box sx={{ height: '100vh' }}><Contact /></Box></SwiperSlide>
      </Swiper>
    </Box>
  );
};

export default App;
